<script lang="ts">
import { modifiers } from "../store";

export let index: number;
export let key: string;

</script>
<div class="form-group mb-3">
	<div class="form-check">
		<input class="form-check-input" type="checkbox" bind:checked={$modifiers[index][key]} id={`Modifiers${index}.${key}`}>
		<label class="form-check-label text-capitalize" for={`Modifiers${index}.${key}`}>
			{key}
		</label>
	</div>
</div>
